import { Component, OnDestroy, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { ComponentCanDeactivate } from 'src/app/shared/pending-changes.guard';

import { DocTypes } from 'src/app/shared/doc-list-entry';
import { DocumentApiService } from 'src/app/services/document-api.service';

@Component({
  selector: 'app-edit-doc-types',
  templateUrl: './edit-doc-types.component.html',
  styleUrls: ['./edit-doc-types.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditDocTypesComponent implements OnInit, OnDestroy, ComponentCanDeactivate {

  docTypes: DocTypes[];

  doctype$: Observable<DocTypes[]>;

  private docTypeQuery: Subscription;

  constructor(
    private docApi: DocumentApiService,
  ) {
  }

  // @HostListener allows us to also guard against browser refresh, close, etc.
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away

    return (true);
  }

  ngOnDestroy(): void {
    console.log('*** EditDocTypesComponent in ngOnDestroy')

    if (this.docTypeQuery) { this.docTypeQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** EditDocTypesComponent in ngOnInit')
    this.docTypeQuery =
      this.docApi.getDocTypes()
        .pipe(map(types => this.docTypes = types))
        .subscribe();
  }
}

